module.exports = __webpack_public_path__ + "media/images/agreements/link_2-3bb84f344aeac3e13efc4147ca65eb5d.png";